module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Vincent Di Maio, Ron Franscell\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Vincent DiMaio, MD, is a pathologist and internationally renowned expert on gunshot wounds. Now a private consultant who's performed more than 9,000 autopsies, he's played pivotal roles in some of the most provocative trials and death investigations of the past 40 years."), _c('br'), _c('br'), _vm._v("Ron Franscell has traversed the open range of journalism, fiction and nonfiction. His journalism has won several national awards, including the Associated Press Managing Editors' national Freedom of Information Award.")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/SLuLG8/tc-custom/9781466875067.jpg?1719372081717",
      "alt": "This image is the cover for the book Morgue"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Morgue\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("In this clear-eyed, gritty, and enthralling narrative, Dr. Vincent Di Maio and veteran crime writer Ron Franscell guide us behind the morgue doors to tell a fascinating life story through the cases that have made DiMaio famous--from the exhumation of assassin Lee Harvey Oswald to the complex issues in the shooting of Florida teenager Trayvon Martin. "), _c('br'), _c('br'), _vm._v("Beginning with his street-smart Italian origins in Brooklyn, the book spans 40 years of work and more than 9,000 autopsies, and Di Maio's eventual rise into the pantheon of forensic scientists.  One of the country's most methodical and intuitive criminal pathologists will dissect himself, maintaining a nearly continuous flow of suspenseful stories, revealing anecdotes, and enough macabre insider details to rivet the most fervent crime fans.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    St. Martin’s Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0